<template>
  <el-table
    :data="blendData"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    class="egl-table other-operating-income-accounts-receivable-registration-table"
    stripe
  >
    <el-table-column
      prop="clientId"
      :label="$locale('dailyClosing.accountsReceivableTable.otherOperatingIncomeAccountsReceivableRegistrationTable.th.customerName')"
      align="center"
    >
      <template slot-scope="scope">
        <!-- <el-select
          v-if="scope.row.rowType !== 'total'"
          v-model="tableData[scope.$index].clientId"
          :placeholder="$locale('dailyClosing.createDialog.otherCashPaymentRegistrationTable.selectPlaceHolder')"
          :filterable="true"
          :clearable="true"
        >
          <el-option v-for="item in clientList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select> -->
        <template v-if="isOpen">
          <remote-select
            v-if="scope.row.rowType !== 'total'"
            type="client"
            v-model="tableData[scope.$index].clientId"
            :formValue.sync="tableData[scope.$index].clientId"
            :isMultiple="false"
            :actionType="$attrs.actionTypeC"
            :isDayClose="true"
          ></remote-select>
          <div v-else class="ta-r">{{ $locale("dailyClosing.createDialog.otherCashCollectionRegistrationTable.total") }}</div>
        </template>
      </template>
    </el-table-column>

    <el-table-column
      prop="otherRevenueId"
      :label="$locale('dailyClosing.accountsReceivableTable.otherOperatingIncomeAccountsReceivableRegistrationTable.th.itemName')"
      align="center"
    >
      <template slot-scope="scope">
        <el-select
          v-if="scope.row.rowType !== 'total'"
          v-model="tableData[scope.$index].otherRevenueId"
          :placeholder="$locale('dailyClosing.createDialog.otherCashPaymentRegistrationTable.selectPlaceHolder')"
          :clearable="true"
          :filterable="true"
          @change="value => changeAction(value, scope.$index)"
        >
          <el-option v-for="item in otherRevList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column
      prop="price"
      :label="$locale('dailyClosing.accountsReceivableTable.otherOperatingIncomeAccountsReceivableRegistrationTable.th.unitPrice')"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="scope.row.rowType !== 'total'"
          :value="tableData[scope.$index].price | currencyFormatter"
          maxlength="14"
          @input="value => inputAction(value, scope.$index, 'price')"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column
      prop="qty"
      :label="$locale('dailyClosing.accountsReceivableTable.otherOperatingIncomeAccountsReceivableRegistrationTable.th.qty')"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="scope.row.rowType !== 'total'"
          :value="tableData[scope.$index].qty | separatorFormatter"
          maxlength="8"
          @input="value => inputAction(value, scope.$index, 'qty')"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column
      prop="unit"
      :label="$locale('dailyClosing.accountsReceivableTable.otherOperatingIncomeAccountsReceivableRegistrationTable.th.unit')"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="scope.row.rowType !== 'total'"
          v-model="tableData[scope.$index].unit"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column
      prop="amount"
      :label="$locale('dailyClosing.accountsReceivableTable.otherOperatingIncomeAccountsReceivableRegistrationTable.th.billingAmount')"
      align="center"
    >
      <template slot-scope="scope" >
        <template v-if="scope.row.rowType !== 'total'">
          {{ scope.row.price * scope.row.qty | currencyFormatter }}
        </template>
        <template v-else>
          {{ scope.row.amount | currencyFormatter }}
        </template>
      </template>
    </el-table-column>

    <el-table-column
      prop="details"
      :label="$locale('dailyClosing.accountsReceivableTable.otherOperatingIncomeAccountsReceivableRegistrationTable.th.details')"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="scope.row.rowType !== 'total'"
          v-model="tableData[scope.$index].details"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.control')" width="112" align="center">
      <template slot-scope="scope">
        <div class="handle ctrl" v-if="scope.row.rowType !== 'subtotal' && scope.row.rowType !== 'total'">
          <el-button
            v-if="tableData.length > 1 && scope.$index < tableData.length"
            class="handle-btn egl-btn-white"
            icon="el-icon-minus"
            @click="removeTableDataAction(scope.$index)"
          ></el-button>
          <el-button
            v-if="scope.$index === tableData.length - 1"
            class="handle-btn egl-btn-white"
            icon="el-icon-plus"
            @click="addTableDataAction"
          ></el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { digtalParser } from "@/utils/common";
import tranfResData from "@/utils/tranfResData";
import { salesAccountsStruct } from "@/assets/js/dailyClosingNew";
import RemoteSelect from "@/components/common/RemoteSelect";

export default {
  name: "OtherOperatingIncomeAccountsReceivableRegistrationTable",
  props: {
    otherRevList: {
      type: Array,
      default: () => [],
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    blendData() {
      if (this.tableData.length === 0) {
        this.addTableDataAction();
      }

      let resultArray = tranfResData(this.tableData);
      const _total = resultArray.map(_list => _list.price * _list.qty).reduce((prev, cur) => {
        return Number(prev) + Number(cur);
      });

      const _base = salesAccountsStruct();
      resultArray.push({
        ..._base,
        rowType: "total",
        amount: _total,
      });

      return resultArray;
    },
  },
  methods: {
    inputAction(value, idx, key) {
      const _value = digtalParser(value);

      if (this.tableData[idx]) {
        this.tableData[idx][key] = _value;
        if (key === "qty") {
          this.tableData[idx].amount = this.tableData[idx].price * _value;
        } else if (key === "price") {
          this.tableData[idx].amount = _value * this.tableData[idx].qty;
        }
      }
    },
    spanMethod({ row, columnIndex }) {
      if (row.rowType === "total") {
        if (columnIndex === 0) {
          return [1, 5];
        } else if (columnIndex < 5) {
          return [0 , 0];
        }
      }
    },
    rowClassName({ row }) {
      if (row.rowType === "subtotal") {
        return "sub-total-row";
      } else if (row.rowType === "total") {
        return "total-row";
      }
      return "";
    },
    addTableDataAction() {
      const _base = salesAccountsStruct();
      this.tableData.push(_base);
    },
    removeTableDataAction(index) {
      this.tableData.splice(index, 1);
    },
    changeAction(value, index) {
      const _data = this.tableData[index];

      if (value) {
        const {
          price = 0,
          qty = 1, //default always 1
          unit,
        } = this.otherRevList.find(_item => _item.id === value);

        _data.price = price;
        _data.qty = qty;
        _data.unit = unit;
        _data.amount = price * qty;
      } else {
        _data.price = 0;
        _data.qty = 0;
        _data.unit = "";
        _data.amount = 0;
        _data.details = "";
      }
    },
  },
  components: {
    RemoteSelect,
  }
};
</script>
